import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./Affiliate.module.css";
import images from "../../assets/images";
import AppTable from "../../components/shared-components/table/AppTable";
import {  CircularProgress } from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import { GET_AFFILIATE_COUNT, GET_AFFILIATE_COUNT_BY_MARKETING_USER, GET_AFFILIATES } from "./api/AffiliateQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";
import { globalContext } from "../../Provider/AppProvider";
import stylesUser from '../Users/Users.module.css'

interface usersUnderAffiliateUser {
    id: string,
    affiliateId: string,
    userFullName: string,
    affiliater_ticket_details: any,
    totalEarnings: number | null,
    noOfUsers: any
}
export interface affiliateUser {
    firstName: string,
    lastName: string,
    emailId: string,
    user: usersUnderAffiliateUser
}


interface affiliateCount{
  aggregate: {
    count: number
  }
}
export interface getAffiliates {
  aId: string,
  aType: string,
  totalAmount: number,
  directPayout: number,
  emailId: string,
  firstName: string,
  indirectPayout: number,
  lastName: string,
  noOfAffiliates: number | null,
  noOfUsers: number | null,
  referralCode: string | null,
  uId: string,
  userFullName: string,
  aStatus: string,
  aCreatedAt: string,
  aUpdatedAt: string,
}
export interface affiliateUsersListType {
  getAffiliates : getAffiliates[],
  getAffiliatesCount: number,
}

interface DisplayAffiliateProps {
  setIsAffiliateDialogOpen: (value: boolean) => void;
  referrerId: string | null
}

const DisplayAffiliate: FunctionComponent<DisplayAffiliateProps> = ({setIsAffiliateDialogOpen, referrerId}) => {
  const { CloseIcon } = images;
  const {error} = ToasterWithMessage();
  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(tempRowsPerPage ? tempRowsPerPage : "") || 10
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [checking, setChecking] = useState<boolean>(false);
  const [selected, setSelected] = useState<number[]>([]);
  const [columnTypes, setColumnTypes] = useState<string>("aUpdatedAt");
  const [sortType, setSortType] = useState<string>("desc");
  const [affiliateUsers, setAffiliateUsers] = useState<affiliateUsersListType>();
  const {globalState, handleGlobalState} = useContext <any>(globalContext)

  const [loading, setLoading] = useState(true);


  const [getAllAffiliates] = useLazyQuery(GET_AFFILIATES,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setAffiliateUsers((prevState) => ({
        ...prevState,
        getAffiliates: data?.getAffiliates,
        getAffiliatesCount: prevState?.getAffiliatesCount ?? 0
      }));
      setLoading(false)
    },
    onError: () => {
      error("Something went wrong!");
    }
  })
  const [getAffiliateCount] = useLazyQuery(globalState.profile.userRole !== "marketing_user" ? GET_AFFILIATE_COUNT : GET_AFFILIATE_COUNT_BY_MARKETING_USER, {
    fetchPolicy: "no-cache",
    onCompleted: (data)=>{
      setAffiliateUsers((prevState) => ({
        ...prevState,
        getAffiliates: prevState?.getAffiliates ?? [],
        getAffiliatesCount: data?.GetAffiliatesCount?.[0]?.totalCount ?? prevState?.getAffiliatesCount ?? 0
      }));
    },
    onError : () =>{
      error("Failed to fetch affiliate records");
    }
  })
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTempRowsPerPage(event.target.value);
  };

  const handlePageChange = (_event: any, newPage: any) => {
    setCurrentPage(newPage);
    setChecking(false);
    setSelected([]);
  };

  const GenerateUsersHeadCells = () => {
    let id = [
      "userFullName",
      "emailId",
      "aType",
    ];
    let labels = [
      "Name",
      "Email",
      "Type",
    ];
    const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
  };

  useEffect(() => {
    getAllAffiliates({
      variables: {
        limit: 10,
        offset: 0,
        order_by: {[columnTypes]: sortType},
        referrerId,
        aStatus: ["Active", "Deactive"]
    }
    })
    getAffiliateCount({
      variables:{
        referrerId,
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=> {
    getAllAffiliates({
      variables: {
        limit: rowsPerPage,
        offset: (currentPage -1)*rowsPerPage,
        order_by: {[columnTypes]: sortType},
        referrerId
    }
    })
    getAffiliateCount({
      variables:{
        referrerId
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentPage,rowsPerPage,sortType,columnTypes,getAllAffiliates])

  const handleCloseDialog = () =>{
    setIsAffiliateDialogOpen(false)
  }

  return (
    <div style={{ width: "100%" }}>
      <>
        <div className={styles.changePassword}>

        {
          loading
        ?  
          <div className={stylesUser.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
        :
        <>
        <div className={styles.title}>
            <div className={styles.changePassword1}>
              {`Affiliates`}
            </div>
            <div className={styles.closeicon} onClick={handleCloseDialog}>
              <img
                src={CloseIcon}
                alt="closeicon"
                onClick={handleCloseDialog}
              />
            </div>
          </div>
        <AppTable
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handlePageChange={handlePageChange}
          setColumnTypes={setColumnTypes}
          sortType={sortType}
          setSortType={setSortType}
          setSelected={setSelected}
          setChecking={setChecking}
          checking={checking}
          selected={selected}
          rowsPerPage={rowsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          list={affiliateUsers}
          tableTitle="affiliatePopup"
          generateHeadCells={GenerateUsersHeadCells}
        />

        </>
        }
        </div>
      </>
    </div>
  );
};

export default DisplayAffiliate;
